// A key de mídia no R2 preserva o nome original do arquivo (pode ter
// espaço, acento, #, ?, & etc) - colar ela direto numa URL sem codificar
// cada pedaço quebra a requisição (ex: um "#" corta o resto da URL, virando
// fragment ao inves de parte do path; um "?" vira início de query string;
// um espaço pode nem chegar codificado no servidor dependendo do
// contexto). Codifica cada trecho separado por "/" individualmente,
// preservando as barras como separador de path - se codificasse a string
// inteira de uma vez, as barras virariam "%2F" e a rota do Django (que usa
// <path:path>) pararia de bater.
export const encodePathSegments = (path) => (path || '').split('/').map(encodeURIComponent).join('/');
